import React from 'react';
import PropTypes from 'prop-types';
import { themer } from '@spp/theme-provider';

// eslint-disable-next-line react/prop-types
/* eslint-disable */
// to prevent jsx-a11y/anchor-has-content error
const NtDisclaimer = ({ theme, content: { heading, text } }) => (
    <div className={theme['nt-disclaimer']}>
        <a className="anchor" id="commercial-disclaimer" />
        <p>{heading}</p>
        <p>{text}</p>
    </div>
);
/* eslint-enable */

NtDisclaimer.propTypes = {
    content: PropTypes.shape({
        heading: PropTypes.string,
        text: PropTypes.string,
    }),
    theme: PropTypes.shape({
        url: PropTypes.string,
    }),
};

NtDisclaimer.defaultProps = {
    content: {
        heading: '',
        text: '',
    },
    theme: {},
};

export default themer('@vg/ui-nt-disclaimer')(NtDisclaimer);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/NtDisclaimer.js
 **/